export const LOCATIONS_IMPORT_TEMPLATE_PATH =
  '/samples/locations-import-template.csv';
export const LOCATIONS_IMPORT_TEMPLATE_FILENAME =
  'locations-import-template.csv';
